import { z } from 'zod';

export const createMembershipSchema = z.object({
  accountId: z.string().regex(/^[0-9a-fA-F]{24}$/, 'Invalid MongoDB ObjectId for accountId'),
  userId: z.string().regex(/^[0-9a-fA-F]{24}$/, 'Invalid MongoDB ObjectId for userId'),
  role: z.enum(['admin', 'member', 'viewer']).optional().default('member'),
  status: z.enum(['active', 'inactive', 'invited']).optional().default('inactive'),
  invitedBy: z.string().regex(/^[0-9a-fA-F]{24}$/, 'Invalid MongoDB ObjectId for invitedBy').optional().or(z.literal('')),
});

export type CreateMembershipFormData = z.infer<typeof createMembershipSchema>;

export type CreateMembershipResponse = {
  membership: {
    id: string;
    accountId: string;
    userId: string;
    role: 'admin' | 'member' | 'viewer';
    status: 'active' | 'inactive' | 'invited';
    joinedAt?: string;
    leftAt?: string;
    invitedBy?: string;
  };
};
